export function formatNumber(value) {
  if (!value) return '0';

  return new Intl.NumberFormat('en-us').format(value);
}
